export default "__VITE_ASSET__yA9VP7xF__"